<div class="metric_whole_graph">
  <div class="Metrics metrics-inner-wrapper" style="border:none">
    <div>
      <fieldset class="summary-fieldset">
        <legend class="summary-legend">{{SummaryLabel}}</legend>
        <ul class="Metrics">
          <li style="border:none" class="primary-color">
            <div style="border:none;" class="Metrics meal-and-percent">{{Exercises}} {{ExercisesLabel}}</div>
          </li>
          <li style="border:none" class="protein-color">
            <div style="border:none;" class="Metrics meal-and-percent">{{Reps}} {{RepsLabel}}</div>
          </li>
          <li style="border:none" class="carbs-color">
            <div style="border:none;" class="Metrics meal-and-percent">{{Minutes}} {{MinutesLabel}}</div>
          </li>
          <!-- <li style="border:none" class="fats-color">
            <div style="border:none;" class="Metrics meal-and-percent">{{CalorieBurned}} {{CalorieBurnedLabel}}</div>
          </li> -->
        </ul>
      </fieldset>
    </div>
  </div>
</div>



